import { DateUtil } from '@util/DateUtil';
import { Transform } from 'class-transformer';

export class FreeTimeSlotDTO {

  @Transform(DateUtil.dateTimeConversion)
  public dateFrom: Date;

  @Transform(DateUtil.dateTimeConversion)
  public dateTo: Date;
}